import React, {useState} from "react";

import './Welcome.css';
import {ConnectionStatus, LogInState} from "../types";
import {authService} from "../services/authService";
import {useAuth} from "../hooks/useAuth";

const Welcome = () => {
    const { setLoggedIn, setRole, setMyUserId } = useAuth();
    const [stage, setStage] = useState<ConnectionStatus>(ConnectionStatus.NoAttempts);
    
    if (stage === ConnectionStatus.NoAttempts) {
        setStage(ConnectionStatus.Connecting);
        authService.checkConnection().then(response => {
            if (response.success){
                setStage(ConnectionStatus.Connected);
            } else {
                setStage(ConnectionStatus.NoConnection);
            }
        });
    }

    if (stage === ConnectionStatus.Connected) {
        setStage(ConnectionStatus.TestingToken);
        authService.testAuth().then(response => {
            if (response.success){
                setStage(ConnectionStatus.TokenTested);
                setRole(response.role!);
                setMyUserId(response.user_id!);
                setLoggedIn(response.token_active? LogInState.LoggedIn : LogInState.TokenExpired);
            } else {
                setStage(ConnectionStatus.TokenTested);
                setLoggedIn(LogInState.NotLoggedIn);
            }
        });
    }
    
    return (
        <div className="welcome-page">
            <h1 className="welcome">Welcome to the ValidationRuler!</h1>
            <p className="status-info">{stage === ConnectionStatus.Connecting? "Checking connection to the server..." :
                stage === ConnectionStatus.NoConnection? "Failed to connect to the server. Try again later..." :
                "Validating your access token..." }</p>
        </div>
    );
};

export default Welcome;